"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getColumnsCount;

function getColumnsCount(params, width) {
  if (typeof params === "number") {
    return parseInt(params);
  }

  var sortedWidths = Object.keys(params).sort(function (a, b) {
    return parseInt(a) - parseInt(b);
  });

  for (var i = 0; i < sortedWidths.length; i++) {
    var current = sortedWidths[i];

    if (width <= parseInt(current)) {
      return params[current];
    }
  } // Return last.


  return params[sortedWidths[sortedWidths.length - 1]];
}
//# sourceMappingURL=getColumnsCount.js.map